<template lang="html">
	<div class="inner-modal">
		<div class="head-modal">
			<div class="head-modal-title">
				{{ (data.isNew) ? 'Ajouter une note' : 'Editer une note' }}
			</div>
			<div class="head-modal-emphase">
				Ajouter une remarque ou un rappel sur un client
			</div>
		</div>
		<div class="body-modal">
			<form class="form-ui column default-form-ui">
				<div class="form-elem-container">
					<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('titre')}">
						<label for="titre">Titre</label>
						<input type="text" name="titre" v-model="title">
					</div>
					<div v-if="errors.has('titre')" class="error-message">{{ errors.first('titre') }}</div>
				</div>
				<div class="form-elem-container">
					<div class="ctn-label ctn-textarea" v-inputUI :class="{error: errors.has('note')}">
						<label for="note">Note</label>
						<textarea name="note" v-model="message"></textarea>
					</div>
					<div v-if="errors.has('note')" class="error-message">{{ errors.first('note') }}</div>
				</div>
				<div class="ctn-cta right row">
					<div class="btn btn-gold" @click="close">{{ (data.isNew) ? 'Annuler' : 'Supprimer' }}</div>
					<div class="btn btn-red" @click="procNote">Sauvegarder</div>
				</div>
			</form>
		</div>
  </div>
</template>

<script>
export default {
	name: 'ModalNewNote',
	props: ['data'],
	data () {
		return {
			title: null,
			message: null
		}
	},
	mounted () {
		if (this.data.note) {
			this.title = this.data.note.title
			this.message = this.data.note.message
		}
	},
	methods: {
		close () {
			if (!this.data.isNew) {
				this.$store.dispatch('deleteNote', {
					clientId: this.data.clientId,
					note: {
						id: this.data.note.id
					}
				})
			}
			this.$emit('close')
		},
		procNote () {
			if (this.data.isNew) {
				this.$store.dispatch('addNote', {
					clientId: this.data.clientId,
					note: {
						title: this.title,
						message: this.message
					}
				})
				this.$emit('close')
			} else {
				this.$store.dispatch('editNote', {
					clientId: this.data.clientId,
					note: {
						id: this.data.note.id,
						title: this.title,
						message: this.message
					}
				})
				this.$emit('close')
			}
		}
	},
	watch: {
		data (value) {
			this.title = value.note.title
			this.message = value.note.message
		}
	}
}
</script>

<style lang="scss" scoped>
	.form-ui {
		width: 500px;
		.form-elem-container {
			width: 100%;
		}
	}
</style>



// WEBPACK FOOTER //
// NewNote.vue?e15871a2